var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212 73V447.5",
    stroke: "currentColor",
    strokeWidth: 32,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480 64H393M393 64H55.5789C41.6459 64 32 77.5 32 89V249V423C32 434.5 41.6459 448 55.5789 448H393M393 64V256V448M480 448H393",
    stroke: "currentColor",
    strokeWidth: 32,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.629 192V320H119.744V237.035H88V215.701C107.029 214.827 124.288 211.413 124.288 192H148.629Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259 319.424V298.987C291.619 267.179 309.752 251.115 309.987 234.603C309.987 224.747 304.269 219.307 293.901 219.307C284.237 219.307 276.493 224.533 268.984 230.485L259.939 205.995C271.565 196.352 285.347 192 299.043 192C324.173 192 340.451 207.765 340.451 232.213C340.451 256.853 321.251 275.776 303.715 291.563H342.669V319.424H259Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameDataIcon);
export default __webpack_public_path__ + "static/media/frame-data-icon.9367281409171c9bfc78ba40bbc0608f.svg";
export { ForwardRef as ReactComponent };